import createGetFormAsyncErrors from './selectors/getFormAsyncErrors';
import plain from './structure/plain';
export default createGetFormAsyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormAsyncErrors.js
// module id = jx/J
// module chunks = 1